<!-- Store Filter Starts -->
<form class="store-filter-form">
  <div class="store-filter">
    <mat-icon class="search-icon">search</mat-icon>
    <!-- Search Icon -->
    <input
      type="text"
      placeholder="Store Name"
      aria-label="Store Name"
      [matAutocomplete]="auto"
      [formControl]="myControl"
      class="store-filter__input"
    />

    <mat-icon class="store-filter__clear-btn" (click)="clearFilter()">close</mat-icon>
    <mat-autocomplete
      (optionSelected)="onStoreSelect($event)"
      #auto="matAutocomplete"
      [displayWith]="displayFn"
    >
      <mat-option
        class="store-filter__item-label"
        *ngFor="let store of filteredOptions | async"
        [value]="store"
      >
        {{ store.storeAttribute.displayName }}
      </mat-option>
    </mat-autocomplete>
  </div>
</form>
<!-- Store Filter Ends -->
